import React from 'react';

import { KEY_MESSAGES_REQUIRE_INPUT_PLACE } from '../../../utilities/constants';
import FieldItemBaseDropdown from './FieldItemBase';

/**
 * エリア
 *
 * @export
 * @class FieldCItemDropdown
 * @extends {React.Component}
 */
export class FieldCItemDropdown extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FieldItemBaseDropdown
        fieldItemType={'c'}
        {...this.props}
        column={KEY_MESSAGES_REQUIRE_INPUT_PLACE[2]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldCItem.jsx